import {PLATFORMS} from 'app/Analytics';
import {load} from 'state/environment/environmentActions';
import {
  getEnvironment,
  selectIsEmbed,
  selectIsPublic,
} from 'state/environment/environmentSelectors';
import {selectIsFeatureEnabled} from 'state/feature/featureSelectors';
import {FEATURE_SWITCHES} from 'app/FeatureSwitches';
import {loadFeatures} from 'state/feature/featureActions';
import {now} from 'utilities/date';
import Request from 'utilities/Request';

let ready = null;

const sendEventToDomo = data => {
  Request.post(`/api/analytics/v1/domoweb`, [data]);
};

export const analyticsInit = store => {
  ready = Promise.all([
    store.dispatch(load()),
    store.dispatch(loadFeatures()),
  ]).then(() => {
    const env = getEnvironment(store.getState());
    const isEmbed = selectIsEmbed(store.getState());
    const isPublicEmbed = selectIsPublic(store.getState());
    const platform = isPublicEmbed
      ? PLATFORMS.PUBLICEMBED
      : isEmbed
      ? PLATFORMS.EMBED
      : PLATFORMS.MOBILE_WEB;
    const configuration = {
      env,
      platform,
      disableAnalytics: selectIsFeatureEnabled(
        store.getState(),
        FEATURE_SWITCHES.DISABLE_ANALYTICS
      ),
    };

    return configuration;
  });
};

export const generalAnalyticsEventData = env => {
  const user = env.user || {};
  const customer = global.ENV.public ? 'public' : env.customer;
  const environment = getEnvironmentName(env);
  return {
    domain: document.domain,
    display_language: global.ENV.locale,
    customer,
    tier_level: env.customerTier ? env.customerTier.toLowerCase() : '',
    unique_user_id: `${customer}-${user.id || 1}`,
    environment,
    domo_version: global.ENV.version,
  };
};

export const analyticsTrack = (eventName, specificEventData = {}) => {
  if (process.env.NODE_ENV !== 'production') return null;
  ready.then(({env, disableAnalytics, platform}) => {
    if (disableAnalytics) return null;
    if (!env.useDomoAnalytics) return null;
    // apiGateway doesn't have support for direct-to-Domo analytics yet
    if (platform === PLATFORMS.PUBLICEMBED) return null;

    sendEventToDomo({
      ...generalAnalyticsEventData(env),
      platform,
      ...specificEventData,
      behavior_name: eventName,
    });
  });
};

function getEnvironmentName(env) {
  let environment = env.environment;
  if (global.ENV.public) {
    environment = /^(public(\.demo)?\.domo\.com)$/.test(
      window.location.hostname
    )
      ? 'prod'
      : 'dev';
  }
  return environment;
}

export const analyticsTrackWithFrameDuration = (
  eventName,
  specificEventData = {}
) => {
  const started = now();
  requestAnimationFrame(() => {
    analyticsTrack(eventName, {
      ...specificEventData,
      duration: now() - started,
    });
  });
};
